export const PAYROLL_RUN_STATUS = {
  deferred: "deferred",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

export const PAYROLL_PERIOD_STATUS_DB = {
  pending: "pending",
  marked_as_paid: "marked_as_paid",
} as const;

export const PAYROLL_RUN_POLL_INTERVAL = 5000; // 5 seconds

export const DEFAULT_USER_DISPLAY_NAME = "You";
